/* eslint-disable */
import * as Types from './types';

import { NailArtInstructionStepFragmentDoc } from './NailArtInstructionStep';
import { ImageFragmentDoc } from './Image';
import { NailArtProductGroupsFragmentDoc } from './NailArtProductGroup';
import { ShareYourLooksFragmentDoc } from './ShareYourLooks';
import { NailArtSectionFragmentDoc } from './SectionNailArt';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type NailArtQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.NailArtFilter>;
  urlCategoryFilter?: Types.InputMaybe<Types.NailArtFilter>;
}>;


export type NailArtQuery = { __typename?: 'Query', nailArtCollection?: { __typename?: 'NailArtCollection', items: Array<{ __typename?: 'NailArt', seoTitle?: string | null, seoDescription?: string | null, title?: string | null, description?: string | null, proOnly?: boolean | null, urlCategory?: string | null, instructions?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null, steps?: { __typename?: 'NailArtInstructionStepsCollection', items: Array<{ __typename?: 'ComponentsNailArtInstructionStep', image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, content?: { __typename?: 'ComponentsNailArtInstructionStepContent', json: object } | null } | null> } | null, video?: { __typename?: 'VideoSection', youtubeVideoId?: string | null, vimeoVideoId?: string | null, video?: { __typename?: 'Asset', url?: string | null, contentType?: string | null } | null, videoPoster?: { __typename?: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null } | null } | null, productGroups?: { __typename?: 'NailArtProductGroupsCollection', items: Array<{ __typename?: 'ComponentsNailArtProductGroup', title?: string | null, productsCollection?: { __typename?: 'ComponentsNailArtProductGroupProductsCollection', items: Array<{ __typename?: 'Product', handle?: string | null, title?: string | null, id?: string | null, shopifyId?: string | null } | null> } | null } | null> } | null, sections?: { __typename?: 'NailArtSectionsCollection', items: Array<{ __typename: 'NailArtSection', title?: string | null, subtitle?: string | null, proContent?: boolean | null, tabsCollection?: { __typename?: 'NailArtSectionTabsCollection', items: Array<{ __typename?: 'NailArtTab', tabTitle?: string | null, tabLink?: string | null, tabCardsCollection?: { __typename?: 'NailArtTabTabCardsCollection', items: Array<{ __typename?: 'NailArtCard', title?: string | null, author?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, proOnly?: boolean | null, description?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null } | { __typename: 'SectionHelloWorld' } | { __typename: 'ShareYourLooks', title?: string | null, description?: string | null, ctaUrl?: string | null, ctaTitle?: string | null, openLinkInNewTab?: boolean | null, proContent?: boolean | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, mobileImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null, images?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null } | null> } | null } | null> } | null };

export declare const nailArt: import("graphql").DocumentNode;

export const NailArtDocument = /*#__PURE__*/ `
    query nailArt($handle: String!, $locale: String = "en-US", $preview: Boolean = false, $tagFilter: NailArtFilter, $urlCategoryFilter: NailArtFilter) {
  nailArtCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: $handle}, $tagFilter, $urlCategoryFilter]}
  ) {
    items {
      seoTitle
      seoDescription
      title
      description
      instructions {
        url
        title
      }
      proOnly
      steps: instructionStepsCollection {
        items {
          ... on ComponentsNailArtInstructionStep {
            ...NailArtInstructionStepFragment
          }
        }
      }
      video {
        video {
          url
          contentType
        }
        videoPoster {
          width
          height
          url
          title
        }
        youtubeVideoId
        vimeoVideoId
      }
      productGroups: productGroupsCollection(
        limit: 3
        where: {sys: {id_exists: true}}
      ) {
        items {
          ... on ComponentsNailArtProductGroup {
            ...NailArtProductGroupsFragment
          }
        }
      }
      sections: sectionsCollection(preview: $preview, where: {sys: {id_exists: true}}) {
        items {
          __typename
          ... on ShareYourLooks {
            ...ShareYourLooksFragment
          }
          ... on NailArtSection {
            ...NailArtSectionFragment
          }
        }
      }
      images: imagesCollection(limit: 8) {
        items {
          width
          height
          url
          title
        }
      }
      urlCategory
    }
  }
}
    ${NailArtInstructionStepFragmentDoc}
${ImageFragmentDoc}
${NailArtProductGroupsFragmentDoc}
${ShareYourLooksFragmentDoc}
${NailArtSectionFragmentDoc}`;
export const useNailArtQuery = <
      TData = NailArtQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: NailArtQueryVariables,
      options?: UseQueryOptions<NailArtQuery, TError, TData>
    ) =>
    useQuery<NailArtQuery, TError, TData>(
      ['nailArt', variables],
      fetcher<NailArtQuery, NailArtQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, NailArtDocument, variables, options),
      options
    );

useNailArtQuery.getKey = (variables: NailArtQueryVariables) => ['nailArt', variables];
;

useNailArtQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: NailArtQueryVariables, options?: RequestInit['headers']) => fetcher<NailArtQuery, NailArtQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, NailArtDocument, variables, options);